import { analytics } from '~entities/amplitude-analytics';

import { atomWithBroadcast } from '~shared/atoms/atom-with-broadcast';

import noop from '@tinkoff/utils/function/noop';

import { setTag } from '@breeze/web-lib-sentry';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import type { UserInfo } from '../auth';

export const userPhoneAtom = atomWithStorage<string | null>(
  'merchant_dashboard_phone',
  null,
  undefined,
  { getOnInit: true }
);

const userInfoInternalAtom = atomWithBroadcast<UserInfo | null>(
  'merchant_dashboard_user_info',
  null
);

export const userInfoAtom = atom((get) => get(userInfoInternalAtom));

export const setUserInfoAtom = atom(
  null,
  (_get, set, userInfo: UserInfo | null) => {
    set(userInfoInternalAtom, userInfo);
    setTag('employeeId', userInfo?.employeeId ?? null);
    if (userInfo) {
      analytics.setUserId(userInfo.employeeId);
    }
  }
);

export const isSessionRestoredAtom = atom(false);

export const isAuthorizedAtom = atomWithBroadcast<boolean | null>(
  'merchant_dashboard_is_authorized',
  null
);

export const lastInteractionTimeAtom = atomWithBroadcast<number | null>(
  'merchant_dashboard_last_interaction_time',
  Date.now()
);

export const resetSessionAtom = atom(noop, (_get, set) => {
  set(isAuthorizedAtom, false);
  set(setUserInfoAtom, null);
  set(lastInteractionTimeAtom, null);
});
